// @flow
import { useState, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import getSubscriptionOptions from '../../api/getSubscriptionOptions';

type InitialState = {
    athleteCount: number,
    invitedAthleteCount: number,
    coachCount: number,
    hasPayingSubscription: boolean,
    hasYearlyLicense: boolean,
    isLicenseOverdue: boolean,
    nextBillingDate: string,
    isCancelPending: boolean,
    isMarketplaceCoach: boolean,
    subscriptions: Array<any>
};

type DefaultState = {
    coachLicenseId: number,
    isCurrentSubscription: boolean,
    isEnabled: boolean,
    title: string,
    maxAthletes: number,
    price: string
};

const INITIAL_STATE: InitialState = {
    athleteCount: 0,
    invitedAthleteCount: 0,
    coachCount: 0,
    hasPayingSubscription: false,
    hasYearlyLicense: false,
    isLicenseOverdue: false,
    nextBillingDate: '',
    isCancelPending: false,
    isMarketplaceCoach: false,
    subscriptions: []
};

export const DEFAULT_STATE: DefaultState = {
    coachLicenseId: 15,
    isCurrentSubscription: true,
    isEnabled: true,
    title: 'Cancelled or Inactive Account',
    maxAthletes: 0,
    price: ''
};

export default function useSubscriptionPlansWithEmbeddedPayment() {
    const [isLoading, setIsLoading] = useState(true);
    const [subscriptionOptions, setSubscriptionOptions] = useState(INITIAL_STATE);

    const [currentPlan, setCurrentPlan] = useState(DEFAULT_STATE);
    const [selectedPlan, setSelectedPlan] = useState(DEFAULT_STATE);

    const [errorLoadingOptions, setErrorLoadingOptions] = useState(false);

    const orgId = useSelector((state: any) => state.user.headCoach?.orgId);

    const fetchSubscriptionOptions = useCallback(async () => {
        if (!orgId) {
            return;
        }

        setIsLoading(true);

        const response = await getSubscriptionOptions(orgId);

        if (response.status) {
            // error
            setErrorLoadingOptions(true);
        }

        const currentPlanFromResponse = response?.subscriptions.filter(plan => plan.isCurrentSubscription);

        if (currentPlanFromResponse.length > 0) {
            setCurrentPlan(currentPlanFromResponse[0]);
            setSelectedPlan(currentPlanFromResponse[0]);
            setSubscriptionOptions(response);
        } else {
            const updatedOptions = [DEFAULT_STATE, ...response.subscriptions];
            setSubscriptionOptions({
                ...response,
                subscriptions: updatedOptions
            });
        }

        setIsLoading(false);
    }, [orgId]);

    useEffect(() => {
        fetchSubscriptionOptions();
    }, [fetchSubscriptionOptions, orgId]);

    return {
        isLoading,
        subscriptionOptions,
        currentPlan,
        setCurrentPlan,
        selectedPlan,
        setSelectedPlan,
        errorLoadingOptions,
        setErrorLoadingOptions,
        fetchSubscriptionOptions
    };
}
